// extracted by mini-css-extract-plugin
module.exports = {"MaxWidthContainer":"MaxWidthContainer_MaxWidthContainer__eMd_l","MaxWidthContainer_forContent":"MaxWidthContainer_MaxWidthContainer_forContent__jK38D"};